export const pages = [
  { path: '/', file: 'index.html', aliases: ['/index', '/index.html'] },
  {
    path: '/sante-relationnelle-clients',
    file: 'index-sante.html',
    aliases: ['/sante-relationnelle', '/index-sante', '/index-sante.html'],
  },
  {
    path: '/memoire-relationnelle-client',
    file: 'index-memoire.html',
    aliases: ['/memoire-relationnelle', '/index-memoire', '/index-memoire.html'],
  },
  {
    path: '/brief-relationnel-ia',
    file: 'brief-relationnel.html',
    aliases: ['/brief-relationnel', '/brief-relationnel.html'],
  },
  {
    path: '/plateforme-intelligence-relationnelle',
    file: 'produit.html',
    aliases: ['/produit', '/produit.html'],
  },
  {
    path: '/business-development-b2b',
    file: 'business-development.html',
    aliases: ['/business-development', '/business-development.html'],
  },
  {
    path: '/productivite-reunions',
    file: 'productivite.html',
    aliases: ['/productivite', '/productivite.html'],
  },
  {
    path: '/score-relationnel-b2b',
    file: 'scoring-relationnel.html',
    aliases: ['/scoring-relationnel', '/scoring-relationnel.html'],
  },
  {
    path: '/methodologie-intelligence-relationnelle',
    file: 'methodologie.html',
    aliases: ['/methodologie', '/methodologie.html'],
  },
  {
    path: '/integrations-crm-email-calendrier',
    file: 'integrations.html',
    aliases: ['/integrations', '/integrations.html'],
  },
  {
    path: '/securite-rgpd-donnees',
    file: 'securite.html',
    aliases: ['/securite', '/securite.html'],
  },
  { path: '/tarifs', file: 'tarifs.html', aliases: ['/tarifs.html'] },
  { path: '/a-propos-tohu-bohu', file: 'a-propos.html', aliases: ['/a-propos', '/a-propos.html'] },
  { path: '/blog', file: 'blog.html', aliases: ['/blog.html'] },
  {
    path: '/blog/capital-relationnel',
    file: 'blog-capital-relationnel.html',
    aliases: ['/blog-capital-relationnel', '/blog-capital-relationnel.html'],
  },
  {
    path: '/blog/big-five-vente-b2b',
    file: 'blog-big-five-vente-b2b.html',
    aliases: ['/blog-big-five-vente-b2b', '/blog-big-five-vente-b2b.html'],
  },
  {
    path: '/blog/granovetter-liens-faibles-reseaux',
    file: 'blog-granovetter-liens-faibles-reseaux.html',
    aliases: ['/blog-granovetter-liens-faibles-reseaux', '/blog-granovetter-liens-faibles-reseaux.html'],
  },
  {
    path: '/blog/kahneman-theorie-perspectives-negociation',
    file: 'blog-kahneman-prospect-theory-negociation.html',
    aliases: [
      '/blog/kahneman-prospect-theory-negociation',
      '/blog-kahneman-prospect-theory-negociation.html',
      '/blog-kahneman-prospect-theory-negociation',
    ],
  },
  {
    path: '/blog/analyse-reseaux-organisationnels-influence',
    file: 'blog-ona-influence-organisationnelle.html',
    aliases: [
      '/blog/ona-influence-organisationnelle',
      '/blog-ona-influence-organisationnelle',
      '/blog-ona-influence-organisationnelle.html',
    ],
  },
  {
    path: '/blog/theorie-echange-social-reciprocite-b2b',
    file: 'blog-social-exchange-theory-reciprocite.html',
    aliases: [
      '/blog/social-exchange-theory-reciprocite',
      '/blog-social-exchange-theory-reciprocite',
      '/blog-social-exchange-theory-reciprocite.html',
    ],
  },
];

export function findPageByLegacyFile(fileName) {
  return pages.find((page) => page.file === fileName);
}

// Résout un href relatif issu des maquettes legacy (ex: "produit.html",
// "index.html#pricing") vers le chemin canonique React (ex:
// "/plateforme-intelligence-relationnelle",
// "/#pricing"). Fonction pure (pas de dépendance à window) : utilisée par le
// script de prerendering (scripts/prerender.mjs) pour réécrire les liens internes
// dans le HTML statique généré, afin qu'un crawler sans JS suive un maillage
// interne correct. La logique de clic côté client (src/components/LegacyPage.jsx)
// reste inchangée et continue de résoudre les liens dynamiquement au runtime.
export function resolveLegacyHref(href, anchorText = '') {
  const normalizedAnchorText = anchorText.replace(/\s+/g, ' ').trim();

  // Le logo Tohu Bohu est le lien de retour à l'accueil. Certaines maquettes
  // le faisaient pointer vers le Brief ou vers "#".
  if (normalizedAnchorText === 'Tohu Bohu') return '/';

  if (!href || href.startsWith('#')) return href;
  if (/^(?:https?:|mailto:|tel:|data:|\/)/i.test(href)) return href;

  const [rawPath, hash] = href.split('#');
  if (!rawPath) return href;
  const fileName = rawPath.split('/').pop();
  // Les maquettes ne sont pas cohérentes sur la destination du lien de
  // navigation « Produit » : certaines utilisent index.html (l'accueil),
  // d'autres brief-relationnel.html. Son libellé lève cette ambiguïté sans
  // modifier les CTA pricing, logos ou autres liens vers ces mêmes fichiers.
  const isProductNavigation = normalizedAnchorText.startsWith('Produit');
  const page = isProductNavigation
    ? pages.find((candidate) => candidate.file === 'produit.html')
    : findPageByLegacyFile(fileName);
  if (!page) return href;
  return hash ? `${page.path}#${hash}` : page.path;
}
